import React from "react";
import { Route } from "react-router-dom";

import ConfigureNetworkPage from "cortex/ui/src/fleet/view/network/ConfigurePage";
import NetworkEdit from "cortex/ui/src/fleet/view/network/NetworkEdit";
import NetworkFlagsPage from "cortex/ui/src/fleet/view/network/NetworkFlagsPage";
import NetworkList from "cortex/ui/src/fleet/view/network/NetworkList";
import NetworkView from "cortex/ui/src/fleet/view/network/NetworkView";

function renderNetworkRoutes() {
  return [
    <Route
      component={NetworkList}
      exact
      key="networks"
      path={["/networks", "/networks/:action(create)"]}
    />,
    <Route
      component={NetworkView}
      exact
      key="network-view"
      path="/networks/:id"
    />,
    <Route
      component={ConfigureNetworkPage}
      exact
      key="network-configure"
      path="/networks/:id/configure"
    />,
    <Route
      component={NetworkFlagsPage}
      exact
      key="network-flags"
      path="/networks/:id/flags"
    />,
    <Route
      component={NetworkEdit}
      exact
      key="network-edit"
      path={`/networks/:id/edit`}
    />,
  ];
}

export { renderNetworkRoutes };
